import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, DownloadSimple } from "@phosphor-icons/react";

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Conversion banner aimed at the OTHER side of the auctioneer directory —
 * the auctioneers themselves. Pitches the white-label / reseller program so
 * they run events on our platform under their own brand, win more events, and
 * bring on more nonprofit clients. Placed alongside NonprofitAuctionCTA on the
 * high-SEO directory pages.
 */
export const AuctioneerWhiteLabelCTA = () => (
    <section className="max-w-5xl mx-auto px-6 my-12" data-testid="auctioneer-whitelabel-cta">
        <div className="relative overflow-hidden bg-secondary/40 border border-border px-8 py-10 sm:px-12 sm:py-12">
            <div className="relative max-w-2xl">
                <p className="label-eyebrow text-accent">For auctioneers &amp; benefit-auction pros</p>
                <h2 className="font-heading text-3xl sm:text-4xl mt-2 leading-tight">
                    Win more events with your own fundraising platform.
                </h2>
                <p className="text-foreground/75 text-sm sm:text-base mt-3 leading-relaxed">
                    White-label CharityFundraiser under your brand — mobile bidding, live
                    paddle-raise, on-site checkout, text-to-give and a donor CRM. Walk into every
                    pitch offering full-service technology, land more nonprofit clients, and earn a
                    new revenue stream on every event.
                </p>
                <div className="flex flex-wrap items-center gap-5 mt-6">
                    <Link
                        to="/for-auctioneers"
                        data-testid="cta-for-auctioneers"
                        className="inline-flex items-center gap-2 bg-primary text-primary-foreground px-7 py-3.5 text-xs uppercase tracking-[0.2em] font-bold hover:opacity-90 transition-opacity"
                    >
                        Explore the white-label program <ArrowRight size={14} weight="bold" />
                    </Link>
                    <a
                        href={`${API}/api/auctioneers/marketing/pitch-sheet.pdf`}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="cta-pitch-sheet"
                        className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-bold text-foreground/75 hover:text-foreground underline underline-offset-4"
                    >
                        <DownloadSimple size={14} weight="bold" /> Free pitch sheet
                    </a>
                </div>
            </div>
        </div>
    </section>
);

export default AuctioneerWhiteLabelCTA;
